import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppConfig} from '../app.config';
import {combineLatest, Observable, of} from 'rxjs';
import {ReportConverter} from './converters/ReportConverter';
import {catchError, map, tap, mergeMap} from 'rxjs/operators';
import {Route} from '../models/segment';
import {CustomHttpParamsEncoder} from './settings/CustomHttpParamsEncoder';
import {Accessibility, MapType} from '../components/management/manage-map/registry';
import { LayerConverter } from './converters/LayerConverter';
import { EntityConverter } from "./converters/EntitiConverter";

@Injectable({
  providedIn: 'root'
})
export class VerifyService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  verifyAccount(token: string, tokenId: string, language: string): Observable<any>  {

    const params = this.createHttpParams()
      .append('language', language);
      
    const body = {
      verificationToken: token,
      verificationTokenId: tokenId
    };

    return this.http.post(this.config.getEndpoint('auth/signup/verify_account'), body, {params});
  }

  resendVerifyLink(email: string, language: string): Observable<any> {
    const body = {
      email: email,
      baseURL: this.config.getVerificationLink(),
      languageEmail: language
    };

    return this.http.post(this.config.getEndpoint('auth/signup/request_verification'), body, {});
  }

  checkLinkedSocialAccounts(): Observable<any> {
    return this.http.post(this.config.getEndpoint('auth/third_party_accounts/linked'), null);
  }

  removeLinkedSocialAccounts(account: string): Observable<any> {
    const params = this.createHttpParams()
      .append('authProvider', account);

    return this.http.post(this.config.getEndpoint('auth/third_party_accounts/remove'), null, {params});
  }

  private createHttpParams(): HttpParams {
    return new HttpParams({encoder: new CustomHttpParamsEncoder()});
  }
}
